"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyRemoveBindOperation = void 0;
exports.verifyRemoveBindOperation = {
    method: 'POST',
    name: 'verifyRemoveBind',
    id: 'verifyRemoveBind',
    groupName: 'evm',
    urlPathPattern: '/bind/remove/verify',
    bodyParamNames: ['message', 'signature'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request) {
    return {
        message: request.message,
        signature: request.signature,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        message: request.message,
        signature: request.signature,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        message: jsonRequest.message,
        signature: jsonRequest.signature,
    };
}
//# sourceMappingURL=verifyRemoveBindOperation.js.map